import { FaFacebook, FaInstagram, FaXTwitter, FaLinkedin, FaYoutube, FaWhatsapp } from "react-icons/fa6";

const SocialCircle = () => {
  // Social media links with icons and their respective colors
  const socialLinks = [
    { icon: <FaLinkedin />, url: "https://www.linkedin.com/company/106045834/admin/dashboard/", color: "#0077B5" },  // LinkedIn (Blue)
    { icon: <FaInstagram />, url: "https://www.instagram.com/mammothofficial_/", color: "#E4405F" }, // Instagram (Pink)
    { icon: <FaXTwitter />, url: "https://x.com/Mammoth_StrWr", color: "#000000" },   // X (Black)
    { icon: <FaWhatsapp />, url: "https://whatsapp.com", color: "#25D366" },  // WhatsApp (Green)
    { icon: <FaYoutube />, url: "https://youtube.com/@mammothstreetwears?si=O7hp4eO1rd1dY7fa", color: "#FF0000" },    // YouTube (Red)
    { icon: <FaFacebook />, url: "https://www.facebook.com/mammothstreetwears/", color: "#1877F2" }   // Facebook (Blue)
  ];

  // Adjust circle radius (distance of icons from center)
  const radius = 150;

  return (
    <div className="relative flex flex-col items-center justify-center mt-24 mb-11">
      {/* Hindi Text Above the Image */}
      <h2 className="absolute top-[-40px] text-xl font-extrabold text-black px-4 py-2 rounded-md">
        देखते रहिए गा
      </h2>

      {/* Image Container */}
      <div className="relative mt-10">
        <img 
          src="https://res.cloudinary.com/djqeoutoy/image/upload/v1739271602/nt6eyzyxbdflpuort1rf.png" 
          alt="Sitting Person" 
          className="w-96 h-96 rounded-full object-cover "
        />

{/* border-4 border-gray-300 */}

        {/* Social Icons in a Half-Circle (Above the Image) */}
        <div className="absolute inset-0 flex justify-center items-center">
          {socialLinks.map((social, index) => {
            // Calculate angles to position icons in the TOP half-circle
            const angle = 220 - (index * 260) / (socialLinks.length - 1); 
            
            // Convert angle to X, Y positions
            const x = radius * Math.cos((angle * Math.PI) / 180);
            const y = -radius * Math.sin((angle * Math.PI) / 180); // Negative Y to position above the image

            return (
              <a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="absolute text-4xl p-2 rounded-full transition"
                style={{ 
                  transform: `translate(${x}px, ${y}px)`,
                  color: social.color // Set icon color dynamically
                }}
              >
                {social.icon}
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SocialCircle;
